App.namespace.wrap('es6.views.login.user_signup', function (options = {}) {
  const FormHandler = App.es6.shared.default_form_handler

  const formClass = '.js-user-signup-form';
  const emailInputSelector = '#client-email';

  const emailErrorLoginSelector = '.email-error-login';
  const emailErrorNoLoginSelector = '.email-error-no-login';
  const emailErrorShowClass = 'email-error-show';
  const emailErrorHideClass = 'email-error-hide';

  const onSubmitSuccess = (response) => {
    let title;
    let text;
    if (response.oldModal) {
      title = 'Almost done! Please verify your email.';
      text = 'Simply check your email and follow the link. You\'ll then be able to easily manage your enquiries in one place.\n';
    } else {
      title = 'You have successfully signed up!';
      text = 'You can now easily manage your enquiries in one place.\n';
    }

    var $modal = $('#js-signup-success-modal');
    $modal.find('.ds-modal-wrapper').addClass('ds-modal-wrapper--visible');
    $modal.find('.ds-modal-overlay').addClass('ds-modal-overlay--visible');
    $modal.find('.ds-modal-title').text(title);
    $modal.find('.ds-modal-content').html(text);
    $modal.find('.ds-modal-actions button, .ds-modal-wrapper').click((e) => {
      e.preventDefault();
      const { redirectUrl } = response;
      window.location = redirectUrl;
    });
    $modal.find('.ds-modal').click((e) => {
      e.stopPropagation();
    });
  }

  function handleLogInPrompt(form) {
    const emailInput = form.find(emailInputSelector);
    const emailErrorLogin = form.find(emailErrorLoginSelector);
    const emailErrorNoLogin = form.find(emailErrorNoLoginSelector);

    emailErrorLogin.addClass(emailErrorShowClass);
    emailErrorNoLogin.addClass(emailErrorHideClass);

    function removeClasses() {
      emailErrorLogin.removeClass(emailErrorShowClass);
      emailErrorNoLogin.removeClass(emailErrorHideClass);

      emailInput.off('input', removeClasses);
    }
    emailInput.on('input', removeClasses);

  }

  const onSubmitError = (errors, form) => {
    if (errors.email && errors.email.length && errors.email[0] === 'Looks like you already have an account. Please log in instead.') {
      handleLogInPrompt(form);
    }
  }

  const init = () => {
    const formHandlerOptions = {
      formClass,
      onSubmitSuccess,
      onSubmitError,
    }
    FormHandler(formHandlerOptions).init()
  }

  return {
    init
  }
})
